<template>
  <div class="form__control">
    <file-pond
      name="upload-image"
      @input="$emit('inputChange', myFile)"
      ref="pond"
      :label-idle="$t('register.uploadImage')"
      :allowFileEncode="true"
      accepted-file-types="image/jpeg, image/png"
      :file="myFile"
      @addfile="handleFilePondInit" />

  </div>
</template>

<script>
  // Import Vue FilePond
  import vueFilePond from 'vue-filepond';

  // Import FilePond styles
  import 'filepond/dist/filepond.min.css';

  // Import FilePond plugins
  // Please note that you need to install these plugins separately

  // Import image preview plugin styles
  import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

  // Import image preview and file type validation plugins
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  import FilePondPluginFileEncode from 'filepond-plugin-file-encode';

  // Create component
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFileEncode);

  export default {
    name: 'AppUploadImage',
    components: {
      FilePond
    },
    data() {
      return {
        myFile: null
      };
    },
    methods: {
      handleFilePondInit() {
        let res = this.$refs.pond.getFile();
        res ? this.myFile = `data:image/png;base64,${res.getFileEncodeBase64String()}` : []
      }
    }
  };
</script>

<style lang="scss">
  .filepond--root {
    font-size: 1.6rem;
    cursor: pointer;
  }

  .filepond--drop-label {
    label {
      cursor: pointer;
    }
  }
</style>
